export default "__VITE_ASSET__4_DZMfuu__"